import React from "react";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import { CustomMainCta } from "./CustomMainCta";
import { CallToActionProps } from "./CallToAction";

const secondaryButtonStyle: StyleRulesCallback = ({ breakpoints, spacing: { unit } }) => ({
  root: {
    [breakpoints.up("sm")]: {
      marginLeft: unit * 2
    },
    [`@media (max-width: ${breakpoints.values.sm - 1}px)`]: {
      marginBottom: unit * 2,
      marginTop: unit * 2
    },
    [`@media (max-width: ${breakpoints.values.sm - 1}px) and (orientation: landscape)`]: {
      marginLeft: unit * 2
    }
  }
});

type Styles = WithStyles<typeof secondaryButtonStyle>;

const SecondaryCtaBase: React.FC<CallToActionProps & Styles> = ({ classes, ...props }) => (
  <CustomMainCta className={classes.root} {...props} />
);

export const SecondaryCta = withStyles(secondaryButtonStyle)(SecondaryCtaBase);
